export default {
    common: {
        actions: '작업',
        add: '추가',
        edit: '수정',
        delete: '삭제',
        search: '검색',
        reset: '초기화',
        export: '내보내기',
        submit: '확정',
        confirm: '확인',
        cancel: '취소',
        enable: '활성화',
        disable: '비활성화',
        expand: '펼치기/접기',
        close: '닫기',
        startDate: '시작 날짜',
        endDate: '종료 날짜',
        to: '부터'
    },
    route: {
        dashboard: '관리 시스템',
        usermanger:'사용자 센터',
        introduction: '개요',
        documentation: '문서',
        permission: '권한 테스트 페이지',
        pagePermission: '페이지 권한',
        directivePermission: '디렉티브 권한',
        icons: '아이콘',
        components: '컴포넌트',
        componentIndex: '소개',
        tinymce: '리치 텍스트 에디터',
        markdown: 'Markdown',
        jsonEditor: 'JSON 에디터',
        dndList: '리스트 드래그',
        splitPane: '스플릿 패인',
        avatarUpload: '아바타 업로드',
        dropzone: '드롭존',
        sticky: '스티키',
        countTo: '카운트To',
        componentMixin: '소형 컴포넌트',
        backToTop: '맨 위로',
        dragDialog: '다이얼로그 드래그',
        dragKanban: '드래그 가능한 칸반',
        charts: '차트',
        keyboardChart: '키보드 차트',
        lineChart: '라인 차트',
        mixChart: '혼합 차트',
        example: '종합 예시',
        Table: '테이블',
        dynamicTable: '동적 테이블',
        dragTable: '드래그 테이블',
        inlineEditTable: '테이블 내 편집',
        complexTable: '복합 테이블',
        treeTable: '트리 테이블',
        customTreeTable: '커스텀 트리 테이블',
        tab: '탭',
        form: '폼',
        createForm: '폼 생성',
        editForm: '폼 편집',
        errorPages: '에러 페이지',
        page401: '401',
        page404: '404',
        errorLog: '에러 로그',
        excel: 'Excel',
        exportExcel: 'Excel 내보내기',
        selectExcel: '선택 내보내기',
        uploadExcel: 'Excel 업로드',
        zip: 'Zip',
        exportZip: 'Zip 내보내기',
        theme: '테마',
        clipboardDemo: '클립보드',
        i18n: '국제화'
    },
    navbar: {
        logOut: '로그아웃',
        dashboard: '대시보드',
        github: '프로젝트 주소',
        screenfull: '전체 화면',
        theme: '테마',
        projectManagement: '프로젝트 관리',
        recycleBin: '휴지통',
        systemManagement: '시스템 관리',
        userManagement: '사용자 관리',
        roleManagement: '역할 관리',
        menuManagement: '메뉴 관리',
        codeGeneration: '코드 생성',
        projectList: '프로젝트 목록',
        automatedReport: '자동 보고서',
        favoritesCenter: '즐겨찾기 센터',
        collaborativeSurvey: '협업 설문',
        pushCenter: '푸시 센터',
        systemSettings: '시스템 설정'
    },
    login: {
        title: '시스템 로그인',
        logIn: '로그인',
        username: '아이디',
        password: '비밀번호',
        any: '임의로 입력',
        thirdparty: '소셜 로그인',
        thirdpartyTips: '로컬에서는 모의 실행이 불가능합니다. 비즈니스 로직에 맞게 모의해주세요!!!'
    },
    loginPage: {
        kickedTitle: '다른 곳에서 로그인됨',
        kickedDesc: '다른 기기에서 계정이 로그인되어 이 기기가 로그아웃되었습니다. 본인이 아니라면 즉시 비밀번호를 변경하세요.',
        loginTitle: '로그인',
        username: '사용자 이름',
        usernameLogin: '사용자 이름/휴대폰 번호',
        loginModePassword: '비밀번호 로그인',
        loginModeSms: '문자 인증번호 로그인',
        loginModeLabel: '로그인 방식',
        password: '비밀번호',
        forgotPassword: '비밀번호를 잊으셨나요?',
        login: '로그인',
        orLoginWith: '또는 소셜 플랫폼으로 로그인',
        registerTitle: '등록',
        register: '등록',
        orRegisterWith: '또는 소셜 플랫폼으로 등록',
        hello: '안녕하세요, 환영합니다',
        noAccount: '계정이 없으신가요?',
        toRegister: '등록',
        welcomeBack: '다시 만나서 반가워요!',
        hasAccount: '계정이 있으신가요?',
        toLogin: '로그인',
        usernameRequired: '사용자 이름을 입력해주세요',
        usernameInvalid: '사용자 이름에는 영문자가 포함되어야 합니다',
        passwordRequired: '비밀번호를 입력해주세요',
        loginSuccess: '로그인 성공',
    },
    documentation: {
        documentation: '문서',
        github: 'Github 주소'
    },
    // ===== 실시간 협업(편집 측 WebSocket) =====
    collab: {
        online: '온라인 협업자',
        someone: '협업자',
        updated: '님이 업데이트했습니다',
        isEditing: '님이 편집 중',
        updatedBadge: '{name} 님이 업데이트함',
        loadLatest: '최신 불러오기',
        overwrite: '내 버전으로 덮어쓰기',
        loadLatestBtn: '상대 버전 불러오기',
        conflictTitle: '저장 충돌',
        conflictDesc: '이 문항이 다른 협업자에 의해 수정되었습니다. 이번 수정은 저장되지 않았습니다.',
        conflictTip: '"내 버전으로 덮어쓰기"는 상대의 수정을 내 내용으로 대체합니다. "상대 버전 불러오기"는 이번 수정을 포기합니다.',
        overwriteSuccess: '덮어쓰기 저장 완료',
        overwriteFail: '덮어쓰기 저장 실패',
        loadedLatest: '상대의 최신 버전을 불러왔습니다',
        reconnecting: '실시간 협업 연결이 끊어졌습니다. 다시 연결하는 중…',
        degraded: '실시간 협업을 일시적으로 사용할 수 없습니다 (자동 재시도 중)'
    },
    permission: {
        roles: '권한',
        switchRoles: '권한 변경'
    },
    components: {
        documentation: '문서',
        tinymceTips: '리치 텍스트는 관리 백엔드의 핵심 기능입니다. 그러나 많은 문제가 있을 수 있습니다. 리치 텍스트를 선택하는 과정에서도 많은 고민을 했습니다. 시중에 있는 대부분의 리치 텍스트는 거의 모두 사용해보았고, 최종적으로 Tinymce를 선택했습니다. 더 자세한 리치 텍스트 비교 및 소개는',
        dropzoneTips: '회사 업무에 특별한 요구사항이 있고, 칠퀸을 전달해야 하므로 타사를 사용하지 않았습니다. 코드는 매우 간단합니다. 자세한 코드는 @/components/Dropzone에서 확인하실 수 있습니다.',
        stickyTips: '페이지가 미리 설정된 위치에 스티키됩니다.',
        backToTopTips1: '페이지가 지정된 위치에 도달하면 오른쪽 하단에 맨 위로 돌아가는 버튼이 나타납니다.',
        backToTopTips2: '버튼 스타일, show/hide, 나타나는 높이, 돌아가는 위치를 사용자 정의할 수 있습니다. 텍스트 힌트가 필요하다면, Element의 el-tooltip 요소를 외부에서 사용하실 수 있습니다.',
        imageUploadTips: '저는 사용 중에 버전이 vue@1이었고, mockjs와 호환되지 않아서 직접 수정했습니다. 만약 여러분이 사용하려면, 우선적으로 공식 버전을 사용하시는 것이 좋습니다.'
    },
    table: {
        dynamicTips1: '고정 헤더, 헤더 순서대로 정렬',
        dynamicTips2: '고정 헤더 없음, 클릭 순서대로 정렬',
        dragTips1: '기본 순서',
        dragTips2: '드래그 후 순서',
        title: '제목',
        importance: '중요도',
        type: '유형',
        remark: '비고',
        reviewer: '검토자',
        id: '번호',
        date: '날짜',
        author: '작성자',
        readings: '읽기 수',
        status: '상태',
        publish: '발행',
        draft: '초안',
    },
    errorLog: {
        tips: '상단 오른쪽 버그 아이콘을 클릭해주세요',
        description: '현재 관리 백엔드는 SPA 형태입니다. 이는 사용자 경험을 개선하지만, 페이지 문제가 발생할 가능성도 증가합니다. 작은 실수로도 전체 페이지가 멈출 수 있습니다. Vue 공식 문서에는 예외를 잡아 처리하거나 오류 보고를 할 수 있는 방법이 제공됩니다. 여기에서 오류 처리 또는 오류 보고를 수행할 수 있습니다.',
        documentation: '문서 소개'
    },
    excel: {
        export: '내보내기',
        selectedExport: '선택된 항목 내보내기',
        placeholder: '파일 이름을 입력하세요(기본값: excel-list)'
    },
    zip: {
        export: '내보내기',
        placeholder: '파일 이름을 입력하세요(기본값: file)'
    },
    theme: {
        change: '테마',
        documentation: '테마 문서',
        tips: '팁: 네비게이션 바의 theme-pick과 다릅니다. 두 가지 다른 테마 방법이 있으며, 각각 다른 응용 사례가 있습니다. 자세한 내용은 문서를 참조하세요.'
    },
    tagsView: {
        close: '닫기',
        closeOthers: '다른 항목 닫기',
        closeAll: '모든 항목 닫기'
    },
    dashboard: {
        kpi: {
            surveyCount: "설문 수",
            userCount: "사용자 수",
            ongoingSurvey: "진행 중인 설문",
            recoveryRate: "설문 회수율"
        },
        trend: "데이터 추세 통계",
        client: "클라이언트",
        browser: "브라우저",
        system: "시스템",
        newSurvey: "새 설문",
        announcement: "공지"
    },
    project: {
        collaborator: {
            sharedWithMe: '공유받은',
            readonly: '보기 전용',
            share: '공유',
            view: '보기',
            sharedFrom: '공유한 사람',
            teamFrom: '팀 구성원',
            orgFrom: '조직 구성원',
            title: '프로젝트 공유',
            tip: '공유된 멤버는 이 프로젝트의 최신 내용(문항, 설정, 응답, 통계)을 볼 수 있지만 수정할 수는 없습니다.',
            searchPlaceholder: '계정 또는 이름으로 검색(2자 이상)',
            search: '검색',
            searchResult: '검색 결과',
            invite: '초대',
            memberList: '공유 멤버',
            emptyMembers: '아직 아무에게도 공유하지 않았습니다',
            emptySearch: '일치하는 사용자를 찾을 수 없습니다',
            remove: '삭제',
            close: '닫기',
            readonlyTip: '이 프로젝트는 보기 전용으로 공유되었습니다. 내용을 볼 수 있지만 수정할 수는 없습니다.',
            needKeyword: '2자 이상 입력하세요',
            inviteSuccess: '이 사용자에게 공유했습니다',
            inviteFail: '공유 실패',
            removeSuccess: '멤버를 삭제했습니다',
            removeFail: '삭제 실패',
            sidebarReadonlyTip: '보기 전용 공유: 내용을 볼 수 있지만 수정할 수는 없습니다',
            bannerPrefix: '이 프로젝트는',
            bannerSuffix: '님이 공유했습니다. 모든 내용(응답 및 통계 포함)을 볼 수 있지만 수정할 수는 없습니다.',
            otherUser: '다른 사용자',
            tip2: '초대된 멤버는 확인 후에 이 프로젝트를 볼 수 있습니다. 확인 후에는 문항, 설정, 응답, 통계를 볼 수 있지만 수정할 수는 없습니다.',
            inviteSent: '초대를 보냈습니다. 상대방의 확인을 기다립니다',
            statusPending: '확인 대기',
            statusAccepted: '참여함',
            statusRejected: '거절됨',
            reinvite: '다시 초대',
            invitePanelTitle: '새로운 프로젝트 공유 초대가 있습니다',
            collapse: '접기',
            expand: '펼치기',
            invitedBy: '초대한 사람',
            accept: '수락',
            reject: '거절',
            acceptSuccess: '초대를 수락했습니다. 목록에 추가되었습니다',
            acceptFail: '수락 실패',
            rejectSuccess: '초대를 거절했습니다',
            rejectFail: '거절 실패',
            searchFailed: '검색 실패',
            tip3: '모듈별로 권한을 설정합니다: "보기만 가능" 모듈은 내용을 볼 수만 있고, "편집 가능" 모듈은 수정할 수 있습니다. 초대받은 사람이 확인하면 적용됩니다. 권한이 없는 모듈은 상대방에게 완전히 보이지 않습니다.',
        },
        permission: {
            module: '모듈',
            none: '권한 없음',
            read: '보기만 가능',
            write: '편집 가능',
            editButton: '권한 변경',
            configTitle: '권한 설정',
            configTitleEdit: '권한 변경',
            save: '저장',
            saveSuccess: '권한이 업데이트되었습니다',
            saveFail: '권한 업데이트에 실패했습니다',
            defaultTip: '기본값은 모두 "보기만 가능"입니다. 필요에 따라 각 모듈의 권한을 조정한 후 초대를 보내세요.',
            pureReadOnlyTip: '"데이터 다운로드"와 "통계 분석"은 보기 전용 모듈로 "편집 가능" 권한이 없습니다.',
            dataWriteTip: '응답 상태 변경이나 응답 삭제(데이터 페이지의 일괄 관리 포함)는 "데이터"를 "편집 가능"으로 설정해야 합니다. "보기만 가능"은 응답 조회만 가능합니다.',
            moreItems: '외 {n}개',
            modules: {
                design: '설문 편집',
                setting: '설문 설정',
                data: '데이터',
                download: '데이터 다운로드',
                statistics: '통계 분석',
                quota: '할당량 관리',
                publish: '게시 및 수집'
            }
        },
        id: "프로젝트 ID",
        name: "프로젝트 이름",
        status: "상태",
        createTime: "생성 시간",
        creator: "생성자",
        all: "전체",
        design: "디자인",
        progress: "게시 중",
        completed: "완료",
        expireOverlayText: '프로젝트가 만료되었습니다. 종료 또는 연장해 주세요',
        extendProject: '연장하기',
        closeProject: '종료하기',
        extendSuccess: '연장되었습니다',
        extendFail: '연장 실패',
        closeSuccess: '프로젝트가 종료되었습니다',
        closeFail: '종료 실패',
        closeProjectTitle: '프로젝트 종료',
        closeProjectTip: '종료 후 설문 링크에 접근할 수 없습니다. 진행하시겠습니까?',
        noData: "데이터 없음",
        stats: "통계",
        search: "검색",
        config: {
            config: '설정',
            info: '정보',
            link: '링크',
            settings: '설정',
            thirdParty: '소셜 설정',
            language: '언어',
            display: '표시',
            status: '상태',
            quota: '할당량',
            baseInfo: '기본 정보',
            projectName: '프로젝트 이름',
            projectDescription: '프로젝트 설명',
            organization: '소속 조직',
            save: '저장',
            linkSettings: '링크 설정',
            surveyLink: '설문 링크',
            shareLink: '공유 링크',
            copy: '복사',
            baseSettings: '기본 설정',
            surveyStatus: '설문 상태',
            on: '켜기',
            off: '끄기',
            allowRepeat: '반복 제출 허용',
            showProgress: '진행률 표시',
            thirdPartyIntegration: '소셜 통합',
            wechat: '웨치트',
            workWechat: '회사 웨치트',
            dingtalk: '딩톡',
            languageSettings: '언어 설정',
            defaultLanguage: '기본 언어',
            supportedLanguages: '지원 언어',
            zhCN: '중국어 간체',
            enUS: '영어',
            displaySettings: '표시 설정',
            themeColor: '테마 색상',
            fontSize: '글꼴 크기',
            showLogo: '로고 표시',
            projectStatus: '프로젝트 상태',
            currentStatus: '현재 상태',
            startTime: '시작 시간',
            endTime: '종료 시간',
            quotaManage: '할당량 관리',
            surveyLimit: '설문 할당량',
            storageLimit: '저장 공간',
            apiLimit: 'API 호출 횟수',
            unitMB: 'MB',
            linkCopied: '링크가 클립보드에 복사되었습니다',
            saving: '설정이 저장되었습니다',
            copySuccess: '복사 성공',
            copyFailed: '복사 실패',
        saveSuccess: '저장 성공',
        saveFailed: '저장 실패',
        finishConfirmTitle: '프로젝트를 완료로 설정',
        finishConfirmMessage: '프로젝트 상태를 "완료"로 설정하면 온라인 설문이 잠기며 더 이상 응답하거나 수정할 수 없습니다. 계속하시겠습니까?',
        finishConfirmButton: '저장하고 잠금',
            ongoing: '진행 중',
            finished: '완료',
            paused: '일시 중지',
            deleted: '삭제됨',
        },
        responses: "응답",
        views: "조회",
        completion: "완료율",
        emptyTip: "데이터 없음",
        emptyCreate: "프로젝트 생성",
        deleteSuccess: "삭제 성공",
        deleteFail: "삭제 실패",
        confirmDelete: "삭제 확인",
        confirmDeleteTip: "프로젝트 \"{name}\"을(를) 삭제하시겠습니까?",
        createProject: {
            createProject: "프로젝트 생성",
            selectType: '프로젝트 유형 선택',
            regular: '일반 설문',
            regularDesc: '새로운 설문 프로젝트를 생성합니다.',
            template: '템플릿 가져오기',
            templateDesc: '미리 설정된 템플릿으로 빠르게 프로젝트를 생성합니다.',
            copy: '프로젝트 복사',
            copyDesc: '기존 프로젝트를 복사합니다.',
            ai: 'AI 분석',
            aiDesc: 'AI를 사용하여 설문 구조를 자동 생성합니다.',
            aiBadge: '테스트 버전',
            downloadExcelTemplate: 'Excel 파일 형식 템플릿 다운로드',
            downloadJsonTemplate: 'JSON 파일 형식 템플릿 다운로드',
            uploadTip: '파일을 여기로 드래그하거나',
            clickUpload: '클릭하여 업로드',
            uploadNotice: '주의: Excel, JSON 파일을 업로드하여 빠르게 프로젝트를 생성하세요.',
            searchProject: '프로젝트 검색',
            search: '검색',
            keepLogic: '로직 유지',
            keepScript: '스크립트 유지',
            createTime: '생성 시간:',
            questionCount: '문항 수:',
            aiPlaceholder: '생성하고자 하는 설문 내용을 입력하세요. 예: 직원 만족도 조사 설문, 근무 환경, 급여, 직업 발전 등의 문항을 포함합니다.',
            aiStart: '분석 시작',
            aiClear: '초기화',
            aiTip1: 'AI는 당신의 설명에 따라 설문 구조를 자동으로 생성합니다.',
            aiTip2: '설명이 더 자세할수록 생성된 설문 구조가 더 정확합니다.',
            info: '프로젝트 정보',
            name: '프로젝트 이름',
            namePlaceholder: '프로젝트 이름을 입력하세요',
            organization: '소속 조직',
            organizationPlaceholder: '소속 조직을 입력하세요',
            description: '프로젝트 설명',
            descriptionPlaceholder: '프로젝트 설명을 입력하세요',
            cancel: '취소',
            create: '프로젝트 생성',
            uploadTemplate: '템플릿 파일을 업로드해주세요',
            selectCopyProject: '복사할 프로젝트를 선택해주세요',
            aiInputRequired: 'AI 분석 내용을 입력해주세요',
            aiParseRequired: '먼저 AI 분석을 실행해주세요',
            createSuccess: '프로젝트 생성 성공',
            createFail: '프로젝트 생성 실패',
            createFailRetry: '프로젝트 생성 실패, 잠시 후 다시 시도해주세요',
        },
    },
    recycle: {
        title: "휴지통",
        id: "프로젝트 ID",
        name: "프로젝트 이름",
        deletedAt: "삭제 시간",
        createdAt: "생성 시간",
        creator: "생성자",
        restore: "복원",
        noData: "데이터 없음",
        confirmDelete: "영구 삭제",
        confirmDeleteTip: "이 프로젝트를 영구적으로 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
        restoreSuccess: "복원 성공",
        restoreFail: "복원 실패",
        deleteSuccess: "삭제 성공",
        deleteFail: "삭제 실패"
    },
    user: {
        title: "사용자 관리",
        id: "사용자 ID",
        name: "사용자 이름",
        mobile: "사용자 전화번호",
        email: "사용자 이메일",
        avatar: "사용자 아바타",
        confirmDelete: "사용자 ID가 \"{id}\"인 데이터를 삭제하시겠습니까?",
        addTitle: "사용자 추가",
        editTitle: "사용자 정보 수정",
        uploadAvatar: "아바타 변경",
        uploadSuccess: "업로드 성공!",
        uploadFail: "업로드 실패: {msg}",
        uploadTypeError: "아바타 이미지는 JPG/PNG 형식이어야 합니다!",
        uploadSizeError: "아바타 이미지 크기는 2MB를 초과할 수 없습니다!",
        placeholderName: "사용자 이름을 입력하세요",
        placeholderMobile: "사용자 전화번호를 입력하세요",
        placeholderEmail: "사용자 이메일을 입력하세요",
        placeholderAvatar: "사용자 아바타 링크를 입력하세요"
    },
    role: {
        title: "역할 관리",
        id: "역할 번호",
        name: "역할 이름",
        key: "권한 문자",
        sort: "표시 순서",
        status: "상태",
        createTime: "생성 시간",
        remark: "비고",
        menuPerm: "메뉴 권한",
        dataPerm: "데이터 권한",
        assignUser: "사용자 할당",
        more: "더 보기",
        confirmDelete: "역할 번호가 \"{id}\"인 데이터를 삭제하시겠습니까?",
        addTitle: "역할 추가",
        editTitle: "역할 수정",
        dataScope: "권한 범위",
        allData: "전체 데이터 권한",
        customData: "사용자 정의 데이터 권한",
        deptData: "부서 데이터 권한",
        deptBelowData: "부서 및 하위 데이터 권한",
        selfData: "단일 사용자 데이터 권한",
        selectAll: "전체 선택/전체 선택 취소",
        parentLink: "부모-자식 연동",
        loading: "로딩 중, 잠시 후 다시 시도해주세요",
        remarkPlaceholder: "내용을 입력하세요",
        successAdd: "추가 성공",
        successEdit: "수정 성공",
        successDelete: "삭제 성공",
        successStatus: "{action} 성공",
        confirmStatus: "{name} 역할을 {action}하시겠습니까?",
        assignDataPerm: "데이터 권한 할당",
        assignUserTitle: "사용자 할당",
        cancelAuth: "권한 취소",
        batchCancelAuth: "일괄 권한 취소",
        closePage: "닫기",
        selectUser: "사용자 선택",
        selectUserTip: "할당할 사용자를 선택해주세요",
        selectUserSuccess: "할당 성공"
    },
    menu: {
        title: "메뉴 관리",
        name: "메뉴 이름",
        icon: "아이콘",
        sort: "정렬",
        perms: "권한 식별자",
        component: "구성 경로",
        status: "상태",
        createTime: "생성 시간",
        confirmDelete: "메뉴 이름이 \"{name}\"인 데이터를 삭제하시겠습니까?",
        addTitle: "메뉴 추가",
        editTitle: "메뉴 수정",
        successAdd: "추가 성공",
        successEdit: "수정 성공",
        successDelete: "삭제 성공",
        placeholderName: "메뉴 이름을 입력하세요",
        placeholderRouteName: "라우팅 이름을 입력하세요",
        placeholderPath: "라우팅 주소를 입력하세요",
        placeholderComponent: "구성 경로를 입력하세요",
        placeholderPerms: "권한 식별자를 입력하세요",
        placeholderQuery: "라우팅 매개변수를 입력하세요",
        placeholderIcon: "아이콘을 선택하세요",
        placeholderParentMenu: "상위 메뉴 선택",
        parentMenu: "상위 메뉴",
        menuType: "메뉴 유형",
        directory: "디렉토리",
        menu: "메뉴",
        button: "버튼",
        menuIcon: "메뉴 아이콘",
        displaySort: "표시 정렬",
        routeName: "라우팅 이름",
        routeNameTip: "라우팅 주소가 기본값과 동일합니다: 예: 주소가 `user`이면 이름이 `User`(특수 경우를 피하기 위해 자동 생성되며, 고유성을 보장하기 위해 필요할 수 있습니다).",
        isExternalLink: "외부 링크",
        externalLinkTip: "외부 링크를 선택하면 라우팅 주소는 `http(s)://`로 시작해야 합니다.",
        routeAddress: "라우팅 주소",
        routeAddressTip: "접근할 라우팅 주소, 예: `user`, 외부 네트워크에서 내부 링크로 접근해야 하는 경우 `http(s)://`로 시작합니다.",
        componentPath: "구성 경로",
        componentPathTip: "접근할 구성 경로, 예: `system/user/index`, 기본적으로 `views` 디렉토리에 있습니다.",
        permissionChar: "권한 문자",
        permissionCharTip: "컨트롤러에서 정의된 권한 문자, 예: @PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "라우팅 매개변수",
        routeParamsTip: "접근할 라우팅의 기본 전달 매개변수, 예: `{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "표시 상태",
        displayStatusTip: "숨김으로 설정하면 사이드바에 나타나지 않지만 여전히 접근할 수 있습니다.",
        menuStatus: "메뉴 상태",
        menuStatusTip: "중지되면 사이드바에 나타나지 않고 접근할 수 없습니다.",
        yes: "예",
        no: "아니오",
        mainCategory: "주 카테고리",
        nameRequired: "메뉴 이름을 입력해야 합니다.",
        sortRequired: "메뉴 순서를 입력해야 합니다.",
        pathRequired: "라우팅 주소를 입력해야 합니다."
    },
    header: {
        lang: {
            zh: '중국어 간체',
            zh_TW: '중국어 번체',
            en: '영어',
            jp: '일본어',
            ko: '한국어',
            id: '인도네시아어',
        },
        helpDoc: '도움말 문서'
    },
    questionEdit: {
        readonlyLocked: '이 프로젝트는 보기 전용이라 내용을 수정할 수 없습니다',
        // 题型名称
        sortQuestion: '정렬 문항',
        singleQuestion: '단일 선택 문항',
        multiQuestion: '다중 선택 문항',
        numberQuestion: '숫자 문항',
        textQuestion: '텍스트 문항',
        dateQuestion: '날짜 문항',
        timeQuestion: '시간 문항',
        uploadQuestion: '업로드 문항',
        scoreQuestion: '점수 문항',
        openQuestion: '개방형 문항',
        timestampQuestion: '타임스탬프',
        selectQuestion: '선택 문항',
        cascadeLevelLabel: '{level}단계 옵션',
        cascadeOptionsManagement: '계단형 옵션 관리',
        placeholderHint: '플레이스홀더: ',
        placeholderInput: '{level}단계 드롭다운 플레이스홀더를 입력하세요',
        manageOptions: '옵션 관리',
        manageSubOptions: '하위 옵션 관리',
        subOptionNamePlaceholder: '하위 옵션 이름을 입력하세요',
        optionTextLabel: '옵션 텍스트',
        optionCodeLabel: '옵션 코드',
        optionTextPlaceholder: '옵션 텍스트를 입력하세요',
        optionCodePlaceholder: '옵션 코드를 입력하세요',
        optionCodeDuplicate: '{level}단계에 중복된 옵션 코드가 있습니다',
        optionCodeDuplicateGlobal: '중복된 옵션 코드가 있습니다. 수정 후 저장하세요',
        optionValueDuplicate: '이 문제에서 옵션 값은 중복될 수 없습니다',
        publishOptionCodeDuplicate: '다음 문제에 중복된 옵션 코드가 있습니다: {questions}. 수정 후 발행하세요',
        matrixSingleQuestion: '행렬 단일 선택 문항',
        matrixMultiQuestion: '행렬 다중 선택 문항',
        matrixBlankQuestion: '행렬 빈칸 문항',
        matrixCompositionQuestion: '행렬 복합 문항',
        matrix: {
            exportOrientation: '주 방향',
            perRow: '행',
            perCol: '열',
            exclusiveLabel: '해당 없음',
            exclusiveNone: '끄기',
            exclusiveRow: '행만',
            exclusiveCol: '열만',
            exclusiveBoth: '행+열',
            transposeStructure: '문항 구조 전치',
            total: '합계'
        },
        thermodynamicChartQuestion: '열 문항',
        combinationQuestion: '조합 문항',
        // 特殊题型
        specialComponents: '특수 문항',
        loopQuestion: '순환 문항',

        // 通用操作
        delete: '삭제',
        clear: '초기화',
        addOption: '옵션 추가',
        batchAdd: '일괄 추가',
        batchAddTitle: '옵션 일괄 추가',
        batchAddHint: '한 줄에 하나의 옵션. Excel에서 두 열을 붙여넣으면 숫자 열이 옵션 값으로 자동 인식되며, 탭이 없을 때는 "1 옵션 텍스트" 형태의 공백 구분도 지원합니다. 인식 결과는 아래에서 미리 보고 드래그로 최종 순서를 조정할 수 있습니다.',
        batchAddPlaceholder: '1\t옵션A\n2\t옵션B\n3\t옵션C',
        batchAddParsedCount: '{count}개의 옵션을 인식했습니다',
        batchAddPreviewTitle: '추가 후 최종 순서',
        batchAddPreviewEmpty: '내용을 붙여넣으면 추가 후의 전체 옵션 목록이 표시됩니다',
        batchAddTagNew: '신규',
        batchAddDragTip: '행 전체를 드래그해 순서를 바꿀 수 있고, 값과 옵션 텍스트도 바로 수정할 수 있습니다',
        batchAddValueTaken: '값 {input}은 같은 문항의 다른 옵션에서 사용 중이므로 {value}(으)로 변경했습니다',
        batchAddValueInvalid: '값 {input}은 올바른 양의 정수가 아니므로 {value}(으)로 변경했습니다',
        batchAddValueAdjustedTip: '{count}개 옵션의 값이 중복되거나 유효하지 않아 사용되지 않은 값으로 변경했습니다. 해당 행의 노란색 아이콘에 마우스를 올리면 이유를 볼 수 있고, 원하는 값으로 직접 바꿀 수도 있습니다.',
        batchAddRowErrorSummary: '{count}개 행을 수정해야 확인할 수 있습니다',
        batchAddRichHint: '이 옵션에는 서식 있는 텍스트가 포함되어 여기서는 일반 텍스트만 표시됩니다. 수정하지 않으면 원래 서식이 유지됩니다',
        batchAddWhitespaceHint: '이 옵션 텍스트는 앞뒤에 공백이 있으며 그대로 유지되어 응답 화면에도 표시됩니다',
        batchAddModeTab: '탭으로 분리',
        batchAddModeSpace: '공백으로 분리',
        batchAddModeTextOnly: '한 줄 전체를 옵션 텍스트로',
        batchAddSuccess: '{count}개의 옵션을 추가했습니다',
        batchAddExistingCount: '기존 {count}개',
        batchAddRemoveExisting: '기존 옵션 삭제',
        batchAddRemoveExistingHint: '기존 옵션을 한 번에 삭제하고 이번에 붙여넣은 항목만 남깁니다',
        batchAddRestoreRemoved: '{count}개 복원',
        batchAddRestoreRemovedHint: '방금 삭제한 기존 옵션을 원래 위치로 되돌립니다',
        batchAddRemoveRowHint: '이 항목 삭제(기존 옵션도 삭제할 수 있습니다)',
        batchAddPreviewEmptyAfterRemove: '기존 옵션 {count}개가 모두 제거되었습니다. 새 옵션을 붙여넣거나 위의 「복원」을 눌러 되돌릴 수 있습니다',
        batchAddNeedOneOption: '미리보기에는 최소 1개의 옵션이 필요합니다',
        batchAddSuccessMixed: '{added}개 추가, {removed}개 삭제했습니다',
        batchDelete: '일괄 삭제',
        batchSelectAll: '전체 선택',
        batchSelectOption: '이 옵션 선택',
        batchSelectedCount: '{count}개 선택됨',
        batchDeleteSelected: '선택 항목 삭제',
        batchDeleteConfirmMessage: '선택한 {count}개의 옵션을 삭제하시겠습니까? 삭제 후 "취소"로 복원할 수 있습니다.',
        batchDeleteSuccess: '{count}개의 옵션을 삭제했습니다',
        batchSelectAllRows: '모든 행 선택',
        batchSelectAllCols: '모든 열 선택',
        batchSelectRow: '이 행 선택',
        batchSelectColumn: '이 열 선택',
        batchSelectedMatrixCount: '{rows}행 · {cols}열 선택됨',
        batchDeleteConfirmMatrix: '선택한 {rows}행, {cols}열을 삭제하시겠습니까? 삭제 후 "취소"로 복원할 수 있습니다.',
        batchDeleteSuccessMatrix: '{rows}행, {cols}열을 삭제했습니다',
        clearConfirmCount: '총 {count}문항',
        loadingMoreQuestions: '이후 문항을 불러오는 중…',
        loadedProgress: '{loaded}/{total}문항 로드됨, 클릭하여 더 불러오기',
        richText: '리치 텍스트',
        confirm: '확인',
        cancel: '취소',

        // 占位符
        optionPlaceholder: '옵션을 입력하세요',
        numberPlaceholder: '숫자를 입력하세요',
        textPlaceholder: '텍스트를 입력하세요',
        datePlaceholder: '날짜를 선택하세요',
        timePlaceholder: '시간을 선택하세요',
        scorePlaceholder: '점수를 입력하세요',
        uploadPlaceholder: '클릭하여 업로드하거나 파일을 여기로 드래그하세요',
        dateFormat: '날짜 시간 형식',
        inputQuestionNo: '문항 번호를 입력하세요',
        scriptType: '스크립트 유형',
        tags: '태그',
        previewDialog: {
            devicePhone: '휴대폰',
            deviceTablet: '태블릿',
            devicePc: 'PC'
        },

        // 검색 및 점프
        searchPlaceholder: '검색어를 입력하세요',
        quickJump: '빠른 이동',
        searchAndJump: '문제 검색 후 선택하여 이동',
        refreshOutline: '개요 새로고침',
        order: '순서',
        orderImportExport: '문제번호 순서 가져오기/내보내기',

        // 提示消息
        saveSuccess: '저장 성공',
        saveFail: '저장 실패',
        deleteSuccess: '삭제 성공',
        deleteFail: '삭제 실패',
        uploadSuccess: '업로드 성공',
        uploadFail: '업로드 실패',
        emptyOptionError: '옵션 내용을 입력해야 합니다.',
        optionValueEmpty: '옵션 값은 비어 있거나 0일 수 없습니다',
        optionEmptyReverted: '옵션 내용이 비어 있어 이전 내용으로 되돌렸습니다. 삭제하려면 오른쪽 삭제 버튼을 사용하세요.',
        addQuestionSuccess: '문항이 추가되었습니다',
        undo: '되돌리기',
        undoSuccess: '직전 변경을 되돌렸습니다',
        undoNoChange: '되돌릴 변경이 없습니다',
        undoFailed: '되돌리기에 실패했습니다. 다시 시도해 주세요',
        switchLanguageSuccess: '언어 변경 성공',
        maxFilesExceeded: '최대 {max}개의 파일만 업로드할 수 있습니다.',
        fileSizeExceeded: '파일 크기는 {size}MB를 초과할 수 없습니다.',

        // 编辑相关
        newOption: '새 옵션',
        editTitle: '제목 수정',
        editOption: '옵션 수정',
        deleteConfirm: '삭제하시겠습니까?',
        deleteConfirmTitle: '삭제 확인',
        titleMarkupLostTitle: '제목에 서식이 포함되어 있습니다',
        titleMarkupLostMessage: '이 제목에는 서식이 포함되어 있습니다. 일반 텍스트로 저장하면 서식이 사라집니다. 계속하시겠습니까? ("서식 있는 텍스트"를 클릭하면 서식을 유지한 채 편집할 수 있습니다.)',
        addNoneOfAbove: '"위 항목 모두 해당 없음" 추가',
        noneOfAbove: '위 항목 모두 해당 없음',
        exclusiveTag: '단일 선택',
        exclusiveTagTip: '단일 선택: 이 항목을 선택하면 다른 항목이 자동으로 해제됩니다',
        exclusiveRemoveTip: '클릭하여 규칙 삭제',
        exclusiveExists: '단일 선택 규칙이 이미 있습니다',
        exclusiveRemoveConfirm: '이 "단일 선택" 규칙을 삭제할까요?',
        exclusiveRemoved: '단일 선택 규칙이 삭제되었습니다',
        exclusiveAdded: '단일 선택 규칙이 추가되었습니다',
        exclusiveLogicSaveFailed: '단일 선택 규칙 저장에 실패했습니다. "로직" 탭에서 직접 추가하세요.',

        // 답변 인용 (앞 질문의 답변을 제목에 삽입)
        answerRef: {
            button: '답변 인용',
            buttonTip: '앞 질문의 답변을 제목에 삽입합니다',
            title: '앞 질문의 답변 인용',
            subtitle: '앞 질문의 답변을 제목에 삽입합니다. 응답 시 응답자가 선택한 내용으로 자동 치환됩니다.',
            search: '질문 번호 또는 제목 검색…',
            empty: '인용할 앞 질문이 없습니다',
            loading: '질문을 불러오는 중…',
            disabled: '지원 안 함',
            disabledTip: '이 질문 유형은 아직 인용할 수 없습니다',
            quickInsert: '삽입',
            modes: '인용 방식',
            modeWhole: '전체 답변',
            modeWholeDesc: '이 질문의 전체 답변을 인용합니다',
            modeOther: '"기타" 입력 내용',
            modeOtherDesc: '"기타"에 입력한 텍스트만 인용합니다',
            modeItem: '{n}번째 항목',
            modeRow: '{n}행',
            modeCell: '{r}행 {c}열',
            modeItemTitle: 'N번째 선택 항목',
            modeItemDesc: '객관식·순위 질문에서 선택한 N번째 항목을 인용합니다',
            modeRowTitle: '행',
            modeRowDesc: '이 행의 답변을 인용합니다',
            modeCellTitle: '셀',
            modeCellDesc: '이 셀의 답변을 인용합니다',
            rowPick: '인용할 행 선택',
            cellPick: '표에서 셀을 클릭하여 선택',
            otherPick: '어떤 "기타"인지 선택',
            itemPick: '몇 번째 항목인지 선택',
            preview: '예시',
            previewPrefix: '미리보기: ',
            unanswered: '미응답 시: {text}',
            unansweredSample: '[미응답]',
            insert: '제목에 삽입',
            cancel: '취소',
            inserted: '인용됨',
            dragHint: '제목 안의 칩을 직접 끌어 위치 조정',
            broken: '인용이 유효하지 않습니다',
            removeRef: '이 인용 삭제',
            brokenTip: '이 질문이 삭제되었거나 번호가 변경되었습니다',
            noPreview: '왼쪽에서 질문을 선택하여 내용을 확인하세요'
        },
        collapse: '접기',
        valueLabel: '값:',
        otherLabel: '기타:',
        netLabel: '그룹:',
        netNone: '-',
        netGroup: 'NET 그룹',
        netGroupPlaceholder: '그룹명을 입력하세요',

        // 默认值
        defaultTitle: '새 문항',
        defaultOption: '옵션 {index}',
        
        //父组件
        // ===== 以下为design父组件template新增key，重复的也保留，后续可微调 =====
        edit: '수정',
        save: '저장',
        statistics: '통계',
        data: '데이터',
        download: '다운로드',
        publish: '발행',
        projectFile: '프로젝트 파일',
        questionType: '문항 유형',
        outline: '목차',
        questionBank: '문항 모음',
        basicComponents: '기본 컴포넌트',
        advancedComponents: '고급 컴포넌트',
        myQuestionBank: '내 문항 모음',
        add: '추가',
        comprehensiveCustomerSatisfactionSurvey: '종합 고객 만족도 조사',
        publicQuestionBank: '공개 문항 모음',
        standardQuestionBankGroup: '표준 문항 그룹',
        standardTextQuestion: '표준 텍스트 문항',
        standardSingleChoiceQuestion: '표준 단일 선택 문항',
        standardMultipleChoiceQuestion: '표준 다중 선택 문항',
        standardOpenQuestion: '표준 개방형 문항',
        standardRatingQuestion: '표준 점수 문항',
        specialQuestionBankGroup: '특수 문항 그룹',
        specialTextQuestion: '특수 텍스트 문항',
        otherQuestionBankGroup: '기타 문항 그룹',
        set: '설정',
        thenExecutionActions: 'THEN 실행 동작',
        beforeExecution: '실행 전',
        duringExecution: '실행 중',
        afterExecution: '실행 후',
        favoriteScript: '즐겨찾기 스크립트',
        personal: '개인',
        details: '상세',
        
        tabSetting: '설정',
        tabLogic: '논리',
        tabScript: '스크립트',
        options: '옵션',
        moreConfig: '더 많은 설정',
        lengthPx: '길이 (px):',
        widthPercent: '너비 (%) :',
        minLength: '최소 문자 수:',
        maxLength: '최대 문자 수:',
        minNumber: '최소 숫자:',
        maxNumber: '최대 숫자:',
        allowChar: '문자:',
        allowNumber: '숫자:',
        allowDecimal: '소수:',
        decimalPlaces: '소수점 자릿수:',
        fontSelect: '글꼴 선택',
        fontSize: '글꼴 크기',
        optionSize: '옵션 크기',
        layoutDirection: '레이아웃 방향',
        horizontal: '가로',
        vertical: '세로',
        rowCount: '행 수',
        rowWidth: '행 너비',
        colCount: '열 수',
        colHeight: '열 높이',
        hideImage: '이미지 숨김',
        operate: '작업',
        saveLogic: '저장 논리',
        logicList: '논리 목록',
        selectCondition: '조건 선택',
        selectOption: '옵션 선택',
        inputValue: '값을 입력하세요',
        selectRelation: '관계 선택',
        priority: '우선순위',
        selectAction: '동작 선택',
        inputText: '텍스트를 입력하세요',
        inputLink: '점프 링크를 입력하세요',
        inputQuestionTitle: '새 질문 제목을 입력하세요',
        selectRowCol: '행/열 선택',
        row: '행',
        column: '열',
        selectRowOption: '행 옵션 선택',
        selectColOption: '열 옵션 선택',
        searchScript: '스크립트 검색',
        detail: '상세',
        scriptEdit: '스크립트 수정',
        scriptDetail: '스크립트 상세',
        search: '검색',
        questionNo: '문항 번호',
        logicSettings: '논리 설정',
        refreshLogic: '논리 새로고침',
        addLogic: '논리 추가',
        ifConditionSettings: 'IF 조건 설정',
        favoriteScriptList: '스크립트 즐겨찾기 목록',
        public: '공개',
        apply: '적용',
        saveScript: '스크립트 저장',
        optionContent: '옵션 내용',
        tabMoreSetting: '설정',
        tabMoreDisplay: '표시',
        tabMoreImage: '이미지',
        fontMicrosoftYaHei: '마이크로소프트 야후',
        fontSimSun: '손편지체',
        fontSimHei: '흑체',
        fontArial: 'Arial',
        Statistics: {
            dashboardTitle: '데이터 분석 대시보드',
            effectiveCount: '유효 회수량',
            totalCount: '총 조사량',
            recoveryRate: '회수율',
            avgTime: '평균 완료 시간',
            deviceModel: '기기 모델',
            dailyTrend: '일별 수집 추세',
            respondentLocation: '응답자 소재 분포',
            briefRecordList: '간단 기록 목록',
            projectId: '프로젝트 ID',
            ipAddress: 'IP 주소',
            deviceType: '기기 모델',
            time: '시간',
            duration: '시간',
            singleChoiceTitle: '단일 선택 문항 답변 분포',
            singleChoiceOption: '옵션 분포',
            multipleChoiceTitle: '다중 선택 문항 답변 분포',
            multipleChoicePeople: '선택 인원',
            optionA: '옵션 A',
            optionB: '옵션 B',
            optionC: '옵션 C',
            optionD: '옵션 D',
            china: '중국',
            usa: '미국',
            europe: '유럽',
            asiaOther: '아시아 기타',
            other: '기타',
            ios: 'iOS',
            android: 'Android',
            windows: 'Windows',
            mac: 'Mac',
        },
        dataView: {
            listTitle: '답변 기록',
            id: 'ID',
            projectId: '프로젝트 ID',
            version: '버전',
            linkType: '링크 타입',
            status: '상태',
            startTime: '답변 시작 시간',
            endTime: '답변 종료 시간',
            createTime: '답변 종료 시간',
            duration: '답변 소요 시간',
            ipAddress: 'IP 주소',
            deviceType: '기기 모델',
            device: '구체적 기기',
            actions: '작업',
            edit: '수정',
            details: '상세',
            editAnswer: '답변 수정',
            cancel: '취소',
            save: '저장',
        },
        downloadView: {
            exportOptions: '내보내기 옵션',
            exportOptionsSubtitle: '내보내기 형식 및 옵션 선택',
            fileFormat: '파일 형식',
            exportOptionsTitle: '내보내기 옵션',
            dateRange: '날짜 범위',
            startDatePlaceholder: '시작 날짜',
            endDatePlaceholder: '종료 날짜',
            startExport: '내보내기 시작',
            excel: 'Excel',
            excelDesc: '데이터 분석 및 처리에 적합',
            csv: 'CSV',
            csvDesc: '모든 기기에 적합한 일반 형식',
            pdf: 'PDF',
            pdfDesc: '인쇄 및 공유에 적합',
            json: 'JSON',
            jsonDesc: '개발자 및 시스템 통합에 적합',
            spss: 'SPSS',
            spssDesc: '통계 분석 소프트웨어에 적합',
            durationUnit: '소요 시간 단위',
            durationSecond: '초',
            durationMinute: '분',
            durationHms: '시:분:초',
            stripRichText: '리치 텍스트',
            audio: '오디오',
            audioDesc: '모든 녹음 파일 일괄 다운로드',
            image: '이미지',
            imageDesc: '업로드 문제 파일 일괄 다운로드',
            includeAnswerTime: '답변 시간 포함',
            includeDeviceInfo: '기기 정보 포함',
            includeIpAddress: 'IP 주소 포함',
            includeLocation: '위치 정보 포함',
            includeUserId: '사용자 식별자 포함',
            includeAnswerType: '답변 유형 포함',
            includeQuestionAnswers: '문항 답변 포함',
            exportImageAnswer: '이미지 답변 내보내기',
        },
        publishProject: {
            title: '프로젝트 발행',
            durationUnit: '소요 시간 단위',
            durationSecond: '초',
            durationMinute: '분',
            durationHms: '시:분:초',
            stripRichText: '리치 텍스트 제거',
            historyLink: '기록 링크',
            generateLink: '링크 생성',
            moreLinks: '추가 링크',
            linkGenerator: '설문 링크 생성기',
            fixedLink: '고정 링크 생성',
            prod1: '공식 링크 1',
            prod1Tip: 'GUID 및 IP 제어 포함',
            prod2: '공식 링크',
            prod2Tip: '공식 배포용. 설문 ID와 이어하기가 자동으로 활성화됩니다',
            test: '테스트 링크',
            testTip: '네비게이션 바 포함, 이전 문항 버튼 표시',
            ipCtrlDeveloping: 'IP 제어 기능은 아직 개발 중입니다',
            breakpointAutoCheckedTip: '{source}를 선택하면 응답 이어하기 제어가 자동으로 체크됩니다',
            breakpointControlledTip: '응답 이어하기 제어는 단독으로 체크할 수 없습니다. GUID 제어 또는 설문 ID를 먼저 선택하세요',
            offline: '오프라인 링크',
            offlineTip: '오프라인 링크',
            custom: '사용자 정의 링크',
            customTip: '사용자 정의 링크',
            customLink: '사용자 정의 링크 생성',
            accessControl: '접근 제어',
            ipCtrl: 'IP 제어',
            guidCtrl: 'GUID 제어',
            surveyIdCtrl: '설문 ID 제어',
            breakpointCtrl: '답변 중단점 제어',
            externalIdCtrl: '외부 식별자 중단점',
            displayOptions: '표시 옵션',
            fixedOptionLockedTip: '고정 링크는 게시 필수 항목이라 해제할 수 없습니다',
            showNav: '네비게이션 바 표시',
            showPrev: '이전 문항 버튼 표시',
            offlineSubmit: '오프라인 링크 보고 재제출',
            createLink: '링크 생성',
            generatedLink: '생성된 링크',
            placeholder: '먼저 링크 생성을 클릭해주세요',
            copy: '복사',
            copySuccess: '링크가 클립보드에 복사되었습니다',
            generateSuccess: '링크 생성 성공!',
            generateFail: '생성 실패',
            history: '기록 링크',
            all: '전체',
            prod: '공식',
            testCategory: '테스트',
            id: '번호',
            link: '링크',
            category: '카테고리',
            type: '유형',
            createTime: '생성 시간',
            disabled: '비활성화',
            yes: '예',
            no: '아니오',
            version: '버전',
            tags: '태그',
            // 종료 상태 발행 차단
            finishBlockedTitle: '발행 불가',
            finishBlockedMessage: '설문이 종료되었습니다. 상태를 조정 후 발행하세요.',
            finishBlockedButton: '알겠습니다'
        },
        resourceManagement: {
            resourceManagement: '자원 관리',
            title: '자원 관리',
            upload: '자원 업로드',
            searchPlaceholder: '자원 검색',
            id: 'ID',
            name: '자원 이름',
            projectId: '프로젝트 ID',
            createTime: '생성 시간',
            url: '자원 링크',
            actions: '작업',
            copyLink: '링크 복사',
            delete: '삭제',
            confirmDelete: '해당 자원을 삭제하시겠습니까?',
            confirm: '확인',
            deleteSuccess: '삭제 성공',
            deleteFail: '삭제 실패',
            copySuccess: '링크가 클립보드에 복사되었습니다',
            fetchFail: '자원 목록 가져오기 실패',
            pageTotal: '총 {total}개',
        },
        resourceUpload: {
            title: '자원 업로드',
            name: '자원 이름',
            namePlaceholder: '자원 이름을 입력하세요',
            file: '자원 첨부파일',
            uploadText: '파일을 여기로 드래그하거나',
            clickUpload: '클릭하여 업로드',
            uploadTip: '주의: 크기 제한은 100MB(JPG, PNG, PDF, DOC, DOCX, XLS, XLSX 형식 지원)',
            cancel: '취소',
            confirm: '확인',
            fileTypeError: '파일 형식 지원되지 않음',
            fileSizeError: '파일 크기는 100MB를 초과할 수 없습니다.',
            nameRequired: '자원 이름을 입력해야 합니다.',
            fileRequired: '업로드할 파일을 선택해야 합니다.',
            uploadSuccess: '업로드 성공',
            uploadFail: '업로드 실패',
            deleteFail: '자원 삭제 실패, 다시 시도해주세요',
        },
    },
    profileView: {
        title: '개인 정보',
        back: '돌아가기',
        edit: '수정',
        save: '저장',
        cancel: '취소',
        username: '사용자 이름',
        avatar: '아바타',
        changeAvatar: '아바타 변경',
        email: '이메일',
        phone: '전화번호',
        usernameRequired: '사용자 이름을 입력해야 합니다.',
        usernameLength: '길이는 3에서 20자 사이여야 합니다.',
        emailRequired: '이메일 주소를 입력해야 합니다.',
        emailFormat: '올바른 이메일 주소를 입력해야 합니다.',
        phoneRequired: '전화번호를 입력해야 합니다.',
        phoneFormat: '올바른 전화번호를 입력해야 합니다.',
        saveSuccess: '저장 성공',
        saveFail: '저장 실패',
        avatarTypeError: '아바타 이미지는 JPG 형식이어야 합니다!',
        avatarSizeError: '아바타 이미지 크기는 2MB를 초과할 수 없습니다!',
    },
    notFound: {
        title: '404',
        pageNotFound: '페이지를 찾을 수 없습니다',
        searching: '원하시는 페이지를 찾고 있습니다...',
        backHome: '홈으로 돌아가기',
    },
    iconSelect: {
        placeholder: '아이콘 이름을 입력하세요',
    },
    tinymce: {
        placeholder: '여기에 텍스트를 입력하세요',
    },
    brands: {
        common: {
            all: '전체',
            id: 'ID',
            actions: '작업',
            search: '검색',
            reset: '초기화',
            refresh: '새로고침',
            edit: '수정',
            delete: '삭제',
            save: '저장',
            cancel: '취소',
            tip: '안내',
            saveFail: '저장 실패',
            deleteFail: '삭제 실패'
        },
        category: {
            title: '브랜드 분류',
            create: '분류 추가',
            listTitle: '분류 목록',
            onlyTop: '1단계만',
            searchPlaceholder: '분류명 검색',
            parentPlaceholder: '1단계 분류',
            childPlaceholder: '2단계 분류',
            level1: '1단계',
            level2: '2단계',
            columns: {
                name: '분류명',
                level: '단계',
                parent: '상위 분류'
            },
            createTitle: '분류 추가',
            editTitle: '분류 수정',
            deleteConfirmMessage: '해당 분류를 삭제하시겠습니까?',
            form: {
                name: '분류명',
                level: '단계',
                parent: '상위 분류',
                levelPlaceholder: '단계를 선택하세요',
                parentPlaceholder: '2단계는 상위 분류가 필요합니다',
                nameRequired: '분류명을 입력하세요',
                levelRequired: '단계를 선택하세요',
                parentRequired: '2단계는 상위 분류가 필요합니다'
            }
        }
    },
    request: {
        kickedOut: '다른 곳에서 계정이 로그인되어 현재 세션이 로그아웃되었습니다. 본인이 아니라면 즉시 비밀번호를 변경하세요.',
        badRequest: '요청 값이 올바르지 않습니다. 입력 내용을 확인해 주세요',
        forbidden: '이 작업을 수행할 권한이 없습니다',
        notFound: '요청한 내용이 존재하지 않거나 삭제되었습니다',
        timeout: '요청 시간이 초과되었습니다. 네트워크를 확인한 후 다시 시도해 주세요',
        payloadTooLarge: '업로드 용량이 너무 큽니다. 압축한 후 다시 시도해 주세요',
        tooManyRequests: '요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요',
        serverError: '서버 처리에 실패했습니다. 잠시 후 다시 시도해 주세요',
        serviceUnavailable: '서비스를 일시적으로 사용할 수 없습니다. 잠시 후 다시 시도해 주세요',
        failedWithStatus: '요청에 실패했습니다({status}). 잠시 후 다시 시도해 주세요',
        networkError: '네트워크 오류가 발생했습니다. 연결을 확인한 후 다시 시도해 주세요'
    }
}
